var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOzon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 20,
    height: 20,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 203 203",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil0 {fill:#005BFF}\n    .fil1 {fill:#FF0856}\n    .fil2 {fill:#FEFEFE;fill-rule:nonzero}\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_643209128"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M166 203l-128 0c-21,0 -38,-17 -38,-37l0 -128c0,-21 17,-38 38,-38l128 0c20,0 37,17 37,38l0 128c0,20 -17,37 -37,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M166 203l-81 0 9 -85 -4 -15 10 -17 38 -6 8 18 57 62 0 6c0,20 -17,37 -37,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M188 60c-1,-6 8,-9 11,-4 2,5 3,10 4,15l0 26c-10,-5 -21,-9 -32,-14 2,6 4,13 5,20 1,4 -5,8 -9,5 -3,-2 -3,-6 -4,-10 -3,-11 -6,-23 -9,-34 4,0 7,2 10,3 10,4 20,9 30,13 -3,-7 -4,-13 -6,-20zm-93 24c10,-9 25,-13 38,-10 8,1 17,7 19,15 2,5 1,9 0,13 -4,8 -9,13 -16,17 -13,6 -28,8 -41,0 -5,-3 -10,-9 -9,-16 -1,-8 4,-14 9,-19zm2 19c1,2 2,5 5,7 8,4 19,3 27,-1 6,-3 11,-7 12,-14 1,-3 -1,-6 -4,-7 -5,-4 -12,-3 -18,-3 -10,2 -20,8 -22,18zm-56 -8c10,-3 21,-6 31,-9 5,-1 7,-1 5,3 -1,3 -2,6 -3,9 -4,9 -8,19 -12,28 6,-1 12,-3 18,-5 3,0 6,0 7,3 2,3 1,7 -2,9 -13,3 -26,6 -39,10 -2,1 -2,-2 -1,-4 5,-12 9,-25 15,-37 -6,2 -11,3 -16,4 -4,2 -7,-2 -8,-6 1,-2 2,-4 5,-5zm-41 11c7,-4 15,-4 22,0 9,5 15,16 13,26 -1,10 -9,19 -19,21 -6,1 -11,-1 -16,-2l0 -16c3,5 10,8 16,6 6,-3 10,-11 7,-18 -2,-6 -10,-10 -17,-7 -2,1 -4,3 -6,5l0 -15z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOzon);
export default __webpack_public_path__ + "static/media/iconOzon.77f4b6e4e5142f64f3a1814db1d6b103.svg";
export { ForwardRef as ReactComponent };